import React, { useState } from 'react';
import { X } from 'lucide-react';
const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const photos = [{
    src: 'https://cdn.magicpatterns.com/uploads/fjvnTVUQkEd37TmoTbHegn/DSC01256.jpg',
    alt: 'Ayevbosa and Abiodun in traditional attire'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/aHFT9CWWV8jAC1q1eVkCeX/DSC01285.jpg',
    alt: 'Couple in traditional wedding attire'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jsDGuLozu3hupQxh5nRhG5/DSC01370.jpg',
    alt: 'Elegant couple portrait in blue'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/hg9YJ9TrcivT8o2GTTBauL/DSC01405.jpg',
    alt: 'Romantic couple moment'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/a2u4FqxK3sws2xkbYfyQy1/DSC01574.jpg',
    alt: 'Casual couple photoshoot'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/tuAsrp7Cw6wYZmQjdyLC7a/DSC01285.jpg',
    alt: 'Ayevbosa in traditional attire'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7Kr3tfKke5bEU75WMA3jc6/DSC01331.jpg',
    alt: 'Ayevbosa and Abiodun together'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/imueeCD9r6PRSmpSFpVJ54/background.png',
    alt: 'Couple portrait'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/gdLbLEhbEgwwwKfGXruLVv/DSC00807.jpg',
    alt: 'Traditional wedding attire'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9NVDYokDEssNKxnhqtJ5SJ/DSC01273.jpg',
    alt: 'Celebration moment'
  }];
  const openModal = (src: string) => {
    setSelectedImage(src);
    document.body.style.overflow = 'hidden';
  };
  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };
  return <section id="gallery" className="bg-white py-20" data-id="element-69">
      <div className="section-container" data-id="element-70">
        <h2 className="section-heading" data-id="element-71">Our Gallery</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-72">
          {photos.map((photo, index) => <div key={index} className="overflow-hidden rounded-md shadow-sm cursor-pointer group" onClick={() => openModal(photo.src)} data-id="element-73">
              <div className="aspect-w-3 aspect-h-4 h-64 overflow-hidden" data-id="element-74">
                <img src={photo.src} alt={photo.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-75" />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-opacity duration-300 flex items-center justify-center" data-id="element-76">
                  <div className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-4 group-hover:translate-y-0" data-id="element-77">
                    View
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {/* Modal */}
      {selectedImage && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4" onClick={closeModal} data-id="element-78">
          <div className="relative max-w-4xl max-h-[90vh]" data-id="element-79">
            <button className="absolute -top-12 right-0 text-white hover:text-emerald" onClick={closeModal} data-id="element-80">
              <X size={28} data-id="element-81" />
            </button>
            <img src={selectedImage} alt="Enlarged view" className="max-w-full max-h-[85vh] object-contain" onClick={e => e.stopPropagation()} data-id="element-82" />
          </div>
        </div>}
    </section>;
};
export default Gallery;